"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var router_1 = require("@angular/router");
var validate_phone_component_1 = require("../validate-phone/validate-phone.component");
var service_service_1 = require("src/app/Services/service.service");
var ValidatePhoneHolderComponent = /** @class */ (function () {
    function ValidatePhoneHolderComponent(route, dialog, services, router) {
        this.route = route;
        this.dialog = dialog;
        this.services = services;
        this.router = router;
        this.enablePhoneRegConfirm = false;
        this._currentUserId = 0;
        this._currentUserPhone = '';
        this.enablePhoneRegConfirm = services.enablePhoneRegConfirm;
    }
    ValidatePhoneHolderComponent.prototype.ngAfterViewInit = function () {
        var userDataObject = JSON.parse(atob(this.route.snapshot.paramMap.get("user_data")));
        if (this.enablePhoneRegConfirm) {
            var dialogRef_1 = this.dialog.open(validate_phone_component_1.ValidatePhoneComponent, {
                width: "650px",
                disableClose: false,
                data: {
                    userData: userDataObject
                }
            });
            dialogRef_1.afterClosed().subscribe(function (v) {
                if (!dialogRef_1.componentInstance.afterRegClose) {
                    //   window.history.back();
                }
            });
        }
        else {
            this.router.navigate(['']);
        }
    };
    Object.defineProperty(ValidatePhoneHolderComponent.prototype, "currentUserId", {
        get: function () {
            return this._currentUserId;
        },
        set: function (value) {
            this._currentUserId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidatePhoneHolderComponent.prototype, "currentUserPhone", {
        get: function () {
            return this._currentUserPhone;
        },
        set: function (value) {
            this._currentUserPhone = value;
        },
        enumerable: true,
        configurable: true
    });
    ValidatePhoneHolderComponent.prototype.ngOnInit = function () {
        // const userDataObject = JSON.parse(atob(this.route.snapshot.paramMap.get("user_data")));
        // if (userDataObject) {
        //   this.currentUserId = parseInt(userDataObject.userId);
        //   this.currentUserPhone = userDataObject.userPhone;
        //  // this.sendPhoneValidationSms(null)
        // }
    };
    return ValidatePhoneHolderComponent;
}());
exports.ValidatePhoneHolderComponent = ValidatePhoneHolderComponent;
